import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import URI from 'urijs';
import { NavLink } from 'react-router-dom';
import stRowsIcon from '../../img/st-rows.svg';

const sidebarLinkPropTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  newLink: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
};

const LinkContent = ({ title, icon, newLink }) => {
  const renderIcon = () => {
    if (!icon) return null;

    if (icon === 'st-icon') {
      return (
        <img src={stRowsIcon} alt="st-rows" className="sidebar__link-icon" />
      );
    }

    return <span className={`sidebar__link-icon lnr lnr-${icon}`} />;
  };

  const renderBadge = () => {
    if (!newLink) return null;

    return (
      <Badge className="sidebar__link-badge">
        <span>New</span>
      </Badge>
    );
  };

  return (
    <React.Fragment>
      {renderIcon()}
      <p className="sidebar__link-title">
        {title}
        {renderBadge()}
      </p>
    </React.Fragment>
  );
};

LinkContent.propTypes = {
  ...sidebarLinkPropTypes,
};

const ExternalLink = ({ route, ...props }) => (
  <li className="sidebar__link">
    <a href={route} className="sidebar__link-title">
      <LinkContent {...props} />
    </a>
  </li>
);
ExternalLink.propTypes = {
  ...sidebarLinkPropTypes,
};

const InternalLink = ({ route, onClick, ...props }) => (
  <li>
    <NavLink
      to={route}
      onClick={onClick}
      className="sidebar__link"
      activeClassName="active"
    >
      <LinkContent {...props} />
    </NavLink>
  </li>
);

InternalLink.propTypes = {
  ...sidebarLinkPropTypes,
};

const SidebarLink = ({ route, ...props }) =>
  URI(route).protocol() ? (
    <ExternalLink route={route} {...props} />
  ) : (
    <InternalLink route={route} {...props} />
  );

export default SidebarLink;
